<template>
  <transition name="slide-down" mode="out-in">
    <div class="flex justify-center items-center h-screen">
      <div class="flex-col w-1/4 mb-4">
        <TextInput
          id="input"
          ref="codeInput"
          autocomplete="one-time-code"
          class="mb-4"
          placeholder="Enter Totp"
          v-model="inputText"
          :max-length="6"
          @enter="submit"/>
        <Button
          type="primary"
          :inFlight="isSubmitting"
          class="text-gray-300 mx-auto"
          @onClick="submit"
        >
          Continue
        </Button>
        <div v-if="errorMessage" class="mt-8">
          <ErrorMessage :error="errorMessage" />
        </div>
        <router-link :to="{ name: 'login' }" class="block mt-4 text-sm text-gray-200">
          Back to Login
        </router-link>
      </div>
    </div>
  </transition>

</template>

<script>
import TextInput from '@/components/TextInput.vue';
import Button from '@/components/Button.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { mapActions } from 'vuex';

export default {
  name: 'TotpVerify',
  components: { Button, ErrorMessage, TextInput },
  async mounted() {
    this.$refs.codeInput.$refs.input.focus();
    try {
      const { data } = await this.totpRecoveryTokens();
      if (this.isActive) this.recoveryTokens = data.recoveryTokens || [];
    } catch {
      this.recoveryTokens = [];
    }
  },
  data() {
    return {
      inputText: '',
      recoveryTokens: [],
      errorMessage: '',
      isSubmitting: false,
      isActive: true,
    };
  },
  beforeDestroy() {
    this.isActive = false;
  },
  methods: {
    ...mapActions(['verifyTotp', 'totpRecoveryTokens']),
    async submit() {
      if (this.isSubmitting) return;
      this.inputText = this.$refs.codeInput.$refs.input.value;
      if (!/^\d{6}$/.test(this.inputText)) {
        this.errorMessage = 'Enter your six-digit code.';
        return;
      }
      this.errorMessage = '';
      this.isSubmitting = true;
      try {
        const status = await this.verifyTotp({ token: this.inputText });
        if (!this.isActive) return;
        if (status === 'inactive') {
          await this.$router.push('/inactive-organization');
        } else if (status === 'authenticated') {
          await this.$router.push('/report');
        } else if (status === 'expired' || status === 'anonymous') {
          await this.$router.replace({ name: 'login' });
        } else {
          this.errorMessage = 'Unable to verify your session. Please try again.';
        }
      } catch (e) {
        if (!this.isActive) return;
        if (e.response && e.response.status === 401) {
          await this.$router.replace({ name: 'login' });
          return;
        }
        const responseData = e && e.response && e.response.data;
        this.errorMessage = !e.response
          ? 'Unable to reach Orbital. Please try again.'
          : (responseData && (responseData.error || responseData.detail))
            || 'The code you entered is incorrect. Please try again.';
        this.inputText = '';
        this.$nextTick(() => {
          if (this.$refs.codeInput) this.$refs.codeInput.$refs.input.focus();
        });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped></style>
